/** @jsxImportSource @emotion/react */
import type { Interpolation } from "@emotion/react";
import { useTranslations } from "@i18n/react";

import type { ThemeType } from "../../../../global/emotion";
import { numericPercentages, spacing } from "../../../../global/emotion";
import type { TextProps } from "../../_base/_core/Text/Text.emotion";
import { Text } from "../../_base/_core/Text/Text.emotion";
import type { AuthMainFlowProps } from "./AuthMainFlow.emotion";

const legalStyle: Interpolation<ThemeType> = (theme) => ({
  color: theme.semanticColors.neutralsMedium,
  marginTop: spacing.ms,
  textAlign: "center",
  width: numericPercentages[100],
});
const legalLinkStyle: Interpolation = {
  textDecoration: "underline",
};

export const AuthLegal = ({
  legalCSS,
  legalProps,
}: Pick<AuthMainFlowProps, "legalProps" | "legalCSS">) => {
  const t = useTranslations();
  return (
    <Text
      css={[legalStyle, legalCSS]}
      {...({
        size: "s",
        type: "body",
        ...legalProps,
      } as TextProps)}
    >
      {t.rich("launch_privacy_and_terms_links", {
        privacy: (chunk) => (
          <a
            href="https://hallow.com/privacy-policy"
            target="_blank"
            css={legalLinkStyle}
          >
            {chunk}
          </a>
        ),
        terms: (chunk) => (
          <a
            href="https://hallow.com/terms-of-service"
            target="_blank"
            css={legalLinkStyle}
          >
            {chunk}
          </a>
        ),
      })}
    </Text>
  );
};
